import { Link } from 'react-router-dom';
import { formatVisitCount } from '@wineryxplorer/shared';
import { Typography } from '../ui/Typography';

const MAX_DATES = 3;

const formatVisitDate = (iso: string): string =>
  new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

export interface CheckInHistoryItem {
  venueId: string;
  venueName: string | null;
  visitCount: number;
  visitDates?: string[];
}

interface CheckInHistoryListProps {
  items: CheckInHistoryItem[];
  showDates: boolean;
}

export const CheckInHistoryList = ({ items, showDates }: CheckInHistoryListProps) => (
  <ul className="divide-y divide-gray-200">
    {items.map((item) => {
      // The API returns dates newest first.
      const dates = showDates ? (item.visitDates ?? []) : [];
      const extra = dates.length - MAX_DATES;

      return (
        <li key={item.venueId} className="py-4 flex flex-col gap-1">
          <div className="flex items-baseline justify-between gap-4">
            {item.venueName ? (
              <Link
                to={`/wineries/${item.venueId}`}
                className="text-gray-900 hover:text-primary-800 hover:underline underline-offset-4"
              >
                <Typography variant="venueName" as="span" className="text-lg">
                  {item.venueName}
                </Typography>
              </Link>
            ) : (
              <Typography variant="bodyMedium" as="span" className="text-gray-600">
                A winery that&apos;s no longer listed
              </Typography>
            )}
            <Typography variant="bodySmall" as="span" className="text-gray-600 whitespace-nowrap">
              {formatVisitCount(item.visitCount)}
            </Typography>
          </div>
          {dates.length > 0 && (
            <Typography variant="bodySmall" className="text-gray-500">
              {dates.slice(0, MAX_DATES).map(formatVisitDate).join(' · ')}
              {extra > 0 && <span className="ml-2">+{extra} more</span>}
            </Typography>
          )}
        </li>
      );
    })}
  </ul>
);
